/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import OptionWrapper from "../others/option-wrapper";
import PropTypes from 'prop-types';
import { forwardRef, memo, useImperativeHandle, useMemo, useRef } from 'react';
import { bgColor, borderNone, flexShrink0, mg, parseWidthHeight } from "../../styles/general";
import { classNames } from "../../utils";
const Divider = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  action = {},
  className,
  color,
  direction,
  height,
  id,
  style,
  width
}, reference) => {
  if (!reference) reference = useRef(null);
  const ref = useRef(null);
  const isVertical = direction === 'vertical';
  const _DividerRoot = DividerRoot(color, width, height, isVertical);
  useImperativeHandle(reference, () => {
    const currentRef = ref.current || {};
    currentRef.element = ref.current;
    const _instance = {
      ...action
    }; // methods
    _instance.__proto__ = {}; // hidden methods
    currentRef.instance = _instance;
    return currentRef;
  });
  return useMemo(() => {
    return jsx("hr", {
      css: _DividerRoot,
      ref: ref,
      id: id,
      style: style,
      className: classNames('DGN-UI-Divider', className)
    });
  }, [className, color, direction, height, id, style, width]);
}));
const DividerRoot = (color, width, height, isVertical) => css`
    ${borderNone};
    ${flexShrink0};
    ${mg(0)};
    ${bgColor(color)};
    ${parseWidthHeight(width || (isVertical ? 1 : '100%'), height || (isVertical ? 'auto' : 1))};
`;
Divider.defaultProps = {
  className: '',
  color: 'system.disabled',
  direction: 'horizontal',
  style: {}
};
Divider.propTypes = {
  /** Class for component. */
  className: PropTypes.string,
  /** The color of the component. */
  color: PropTypes.string,
  /** direction of divider */
  direction: PropTypes.oneOf(['vertical', 'horizontal']),
  /** Height oof the component. */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Style inline of component. */
  style: PropTypes.object,
  /** Width of the component. */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export { Divider };
export default OptionWrapper(Divider);